var getActivities = {
	config : {
		ajaxTimeout : 5000,
		attempts : 0,
		totals: [0,0,0,0], //MOC, CME, LOC, CE, EBAC
		totalsMap: ['ABIM MOC','CME','LOC','CE'],
		ebacTotals: 0,
		completed : [],
		ebacConfig: {},
		summary: {},
		simplify: {}
	},
	init : function() {
	
	
	},
	getActivitiesByDate : function(target) {
		var refineTarget;
		if (typeof target == 'undefined' || target === '') {
			refineTarget = '.cmeCredits';
		}
		else {
			refineTarget = target;
		}
		var newDate = new Date();
		var thisYear = newDate.getFullYear();
		var lastYear = thisYear-1;
		var userActivitiesUrl = "//www." + getDomain() + "medscape.org/activityservice/activitytracker/v2/json?fmonth=1&fyear="+lastYear+"&tmonth=12&tyear="+thisYear;
		$.ajax({
			cache: false,
			type: "GET",
			timeout: getActivities.config.ajaxTimeout,
			contentType: 'application/json',
			dataType: "json",
			url: userActivitiesUrl,
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(json) {
				var tempTotal = 0;
                getActivities.config.totals = [0, 0, 0, 0];
                getActivities.config.ebacTotals = 0;
				$.each(json.Completed, function(key, value){
					// this is to dynamically map CE as the totalsMap last item is considered as CE
					var keyItem = (key === 'MOC' || key === 'CME' || key === 'LOC')? key : getActivities.config.totalsMap[getActivities.config.totalsMap.length-1];
					if(!getActivities.config.ebacConfig[keyItem]) {
						getActivities.config.ebacConfig[keyItem]={};	
					}
					$(value).each(function(i, item){
						if(item.accreditorPri == 1073) {
							if(!getActivities.config.ebacConfig[keyItem]["EBAC"]) {
								getActivities.config.ebacConfig[keyItem]["EBAC"]=[]
							}
							getActivities.config.ebacConfig[keyItem]["EBAC"].push({credit: parseFloat(item.credit), currentYear: item.participation.includes(new Date().getFullYear())});						
						}
						else {
							
							if(!getActivities.config.ebacConfig[keyItem][keyItem]) {
								getActivities.config.ebacConfig[keyItem][keyItem]=[]
							}
							getActivities.config.ebacConfig[keyItem][keyItem].push({credit: parseFloat(item.credit), currentYear: item.participation.includes(new Date().getFullYear())});
						}
						if (this.referrerUri != null) {
							var viewArt = Number(this.referrerUri.replace('/viewarticle/',''))
							getActivities.config.completed.push(viewArt);
							var yearCompleted = Number((this.participation).split('/')[2]);
							if (yearCompleted === thisYear) {
								if (this.accreditorPri == 1073 ){
                                    getActivities.config.ebacTotals += Number((this).credit);
                                }else {
                                    tempTotal = tempTotal + Number((this).credit);
                                }
							}
						}
					});
					if (key === 'MOC' || key === 'CME' || key === 'LOC') {
						if (key === 'MOC') {
							getActivities.config.totals[0] = getActivities.config.totals[0] + tempTotal
							tempTotal = 0;
						}
						else if (key === 'CME') {
							getActivities.config.totals[1] = getActivities.config.totals[1] + tempTotal
							tempTotal = 0;							
						}
						else if (key === 'LOC') {
							getActivities.config.totals[2] = getActivities.config.totals[2] + tempTotal
							tempTotal = 0;
						}
					}
					else {
						getActivities.config.totals[3] = getActivities.config.totals[3] + tempTotal
						tempTotal = 0;
					}
				});
				
				getActivities.config.summary = Object.fromEntries(getActivities.config.totalsMap.map((v, i)=>[v, getActivities.config.totals[i]]))
				getActivities.config.simplify= getActivities.config.totalsMap.reduce(function(all, item, index){
					    if(getActivities.config.summary[item] != 'undefined') {    
					        const keymap = (item.includes("ABIM")?"MOC": item);
					        if(getActivities.config.ebacConfig[keymap] && getActivities.config.ebacConfig[keymap][keymap]){
					            all[item] = getActivities.config.ebacConfig[keymap][keymap].filter(v => v.currentYear).reduce((a,i,v)=> a+parseFloat(i.credit),0);
					        }
					        if(getActivities.config.ebacConfig[keymap] && getActivities.config.ebacConfig[keymap]["EBAC"]){
					           all["EBAC"] =  all["EBAC"]+getActivities.config.ebacConfig[keymap]["EBAC"].filter(v => v.currentYear).reduce((a,i,v)=> a+parseFloat(i.credit),0);
					        }
						}
					return all;
				},{"EBAC":0})
				if (refineTarget === '.tracker-modal') {
					getActivities.displayTotals(refineTarget);
				}
				else {
					getActivities.displayEBACTotals(refineTarget);
				}
				getActivities.checkComplete();
			},
			error: function(jqXHR, textStatus, errorThrown) {
				if (getActivities.config.attempts < 1) {
					/*
					$('.popup-window-header').html('Just a moment...');
					$('.popup-window-text').html("It is taking longer than expected to retrieve your credit information.  Please be patient.");
					$('#popup-window .view-credit-button-wrapper').hide();
					displayElements.popupWindow();				
					*/
					getActivities.config.ajaxTimeout = 10000;
					getActivities.config.attempts++;
					getActivities.getActivitiesByDate();
				}
				else {
					getActivities.config.attempts = 0;
					console.log("problem connecting with service");
					$('#tracker .cmeCredits').html('Unable to load credits');

					//create an empty json object and run through as if there was a successful call so the page doesn't look broken when there is a service error
					var json = {"status":{"statusCode":0,"message":""},"Tracker":{"fName":"Service","lName":"Error"},"inprogressActivitiesCount":0,"InProgress":{},"completedActivitiesCount":0,"Completed":{}}			
				}
			}
		});
		return false;
	},
	displayTotals : function(refineTarget){
		var theMarkup = '';
		var theLocMarkup ='';
		$.each(getActivities.config.totals, function(i){
			var trailingZero = '';
			if (this % 1 === 0) {
				trailingZero = '.0';
			}
			if (Number(this) > 0) {
				if (Number(this) === 2) {
					theLocMarkup += '<div class="credits-by-type"><span class="credits-amount">';
					theLocMarkup += Number(this) + trailingZero;
					theLocMarkup += '</span><span class="credit-name">';
					theLocMarkup += getActivities.config.totalsMap[i]
					theLocMarkup += '</div>';
				}
				else {
					theMarkup += '<div class="credits-by-type"><span class="credits-amount">';
					theMarkup += Number(this) + trailingZero;
					theMarkup += '</span><span class="credit-name">';
					theMarkup += getActivities.config.totalsMap[i]
					theMarkup += '</span></div>';
				}
			}
		});
		if ($(theMarkup+theLocMarkup).length > 0) {
			$(refineTarget).html('<div class="totals-by-type">'+theMarkup+theLocMarkup+'</div>');
		}
		else {
			$(refineTarget).html('<div class="totals-by-type"><div class="credits-by-type"><span class="credits-amount">0</span><span class="credit-name">Credits</span></div></div>');
		}
		if (refineTarget === '.tracker-modal') {
			if(getActivities.config.ebacTotals > 0){
				$('.tracker-modal').append('<div class="bb-ebac-credits">' + getActivities.config.ebacTotals*60 + ' minutes of EBAC</div>');
			}
			$('.tracker-modal').append('<div class="morelink"><a href="/activitytracker">View Tracker</a></div>');
		}
	},
	displayEBACTotals : function(refineTarget){
		var theMarkup = '';
		var theLocMarkup ='';
		var theEbacMarkup ='';
		var allCreditKeyTypes = Object.keys(getActivities.config.simplify);

		allCreditKeyTypes.forEach(function(val, idx, allArr){
			if((allArr.length >= 4 && val === 'LOC') || (val === 'EBAC' && getActivities.config.simplify[val] <= 0)) {
				return;
			}
			var trailingZero = '';
			if (getActivities.config.simplify[val] % 1 === 0) {
				trailingZero = '.0';
			}
			if (val === 'EBAC') {
				theEbacMarkup += '<div class="credits-by-type"><span class="credit-name">';
				theEbacMarkup += val;
				theEbacMarkup += '</span><span class="credit-amount">';
				theEbacMarkup += getActivities.config.simplify[val]*60+' min';
				theEbacMarkup += '</div>';
			}
			else if (val === 'LOC') {
				theLocMarkup += '<div class="credits-by-type"><span class="credit-name">';
				theLocMarkup += val;
				theLocMarkup += '</span><span class="credit-amount">';
				theLocMarkup += getActivities.config.simplify[val] + trailingZero;
				theLocMarkup += '</div>';
			}
			else {
				theMarkup += '<div class="credits-by-type"><span class="credit-name">';
				theMarkup += val;
				theMarkup += '</span><span class="credit-amount">';
				theMarkup += getActivities.config.simplify[val] + trailingZero;
				theMarkup += '</span></div>';
			}
		})
		
		if ($(theMarkup+theLocMarkup+theEbacMarkup).length > 0) {
			$(refineTarget).html('<div class="totals-by-type">'+theMarkup+theLocMarkup+theEbacMarkup+'</div>');
		}
		else {
			$(refineTarget).html('<div class="totals-by-type"><div class="credits-by-type"><span class="credit-name">Credits</span><span class="credit-amount">0</span></div></div>');
		}
		if (refineTarget === '.tracker-modal') {
				$('.tracker-modal').append('<div class="morelink"><a href="/activitytracker">View Tracker</a></div>');
		}
	},
	checkComplete : function(){
		$('#activities .card .activityTitle a').each(function(i){
			var self = this;
			var numberPattern = /\d+/g;
			var theArticle = Number($(this).attr('href').match(numberPattern));
			if ($.inArray(theArticle, getActivities.config.completed) > -1) {
				$(self).closest('.card').find('.completed-activity-wrapper').remove()
				$(self).closest('.card').prepend('<div class="completed-activity-wrapper"><div class="completed-activity">Activity Completed</div></div>');
			}
		});
	}
}